import React, { memo } from 'react';
import { Global, css } from '@emotion/core';
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';
import { Theme } from '@nykaa/ui-components/themes/types';

import Normalize from './Normalize';
import Fonts from './Fonts';
import Icons from './Icons';

import { FONT_SIZES, BASE_FONT } from './base';

function BaseStyles() {
  const theme: Theme = useTheme();
  
  const baseStyles = css`
    html {
      font-size: ${FONT_SIZES.BASE};
      overscroll-behavior-y: none;
    }

    body {
      overscroll-behavior-y: none;
      font-family: ${BASE_FONT};
      font-size: ${FONT_SIZES.BASE};
      line-height: 1.42857143;
      color: ${theme?.colors?.textPrimary || '#333'};
      background-color: ${theme?.colors?.surface || '#fff'};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

  html * {
    box-sizing: border-box;
  }

  a {
    color: #000;
  }

  * {
    -webkit-tap-highlight-color: transparent;
    -moz-tap-highlight-color: transparent;
  }

  .flex {
    display: flex;
  }

  .hide {
    display: none;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .uppercase {
    text-transform: uppercase;
  }
`;

  return (
    <>
      <Normalize />
      <Fonts />
      <Icons />
      <Global styles={baseStyles} />
    </>
  );
}

export default memo(BaseStyles);
